import axios from "./axios";

/**
 * Fetches the list of users for the Utility / User Management page.
 * Backend endpoint: GET /api/utility/users (or as configured).
 */
export const getUserList = async () => {
  try {
    const response = await axios.get("/utility/users");
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Fetches a single user by id for editing.
 */
export const getUserById = async (id) => {
  const response = await axios.get(`/utility/users/${id}`);
  return response.data;
};

/**
 * Updates an existing user. Password is optional (omit or leave blank to keep current).
 */
export const updateUser = async (id, data) => {
  const response = await axios.put(`/utility/users/${id}`, data);
  return response.data;
};

/**
 * Creates a new user. Body: { firstName, lastName, email, password, occupation }
 */
export const createUser = async (data) => {
  const response = await axios.post("/utility/users", data);
  return response.data;
};

/**
 * Extend user subscription. Body: { newExpiryDate: "YYYY-MM-DD" } or { extendByMonths: number }
 */
export const extendSubscription = async (userId, data) => {
  const response = await axios.put(`/utility/users/${userId}/extend`, data);
  return response.data;
};
